export default __webpack_public_path__ + "static/planning-e8af5e8f76c583dde95c30c7efdb4749.jpg";